import { IGrotFilter } from "./IGrotFilter";
import { IMaskinLagBase } from "./IMaskinLagBase";

export class GrotFilter implements IGrotFilter {
    skordad: boolean;
    skordadFrom: string;
    skordadTo: string;
    grotanpassad: boolean;
    grotRelateratRundvirkeProduktionGodkand: boolean;
    grotRelateratRundvirkeMaskinlag: IMaskinLagBase[];
    constructor() {
        this.grotanpassad = undefined;
        this.grotRelateratRundvirkeMaskinlag = [];
    }
}
